module.exports = __webpack_public_path__ + "static/img/jjfa_04.7ff2742.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jjfa_04.jpg
// module id = d9H5
// module chunks = 1